// Helper centralisé pour pousser des événements GTM dans le dataLayer.
// Tous les events sont automatiquement filtrés par le wrapper installé dans main.tsx
// (routes privées + trafic interne).

type DataLayerEvent = Record<string, unknown> & { event: string };

const dl = (): unknown[] => {
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  return w.dataLayer;
};

export const gtmPush = (event: DataLayerEvent) => {
  try {
    (dl() as { push: (e: unknown) => void }).push({
      ...event,
      page_path: event.page_path ?? window.location.pathname,
    });
  } catch {
    // no-op
  }
};

/**
 * Pousse un événement de soumission de formulaire au dataLayer.
 * @param formType identifiant logique du formulaire (contact, inscription, candidature, candidature_spontanee, etc.)
 * @param extra données contextuelles supplémentaires (offre_id, source, etc.)
 */
export const trackFormSubmission = (
  formType: string,
  extra: Record<string, unknown> = {}
) => {
  gtmPush({
    event: "form_submission",
    form_type: formType,
    click_location: "section",
    ...extra,
  });
};
